// funckja z excela =LOG(num1, num2)
export const getBaseLog = (y: number, x: number): number => {
  return Math.log(y) / Math.log(x);
};
